var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2858 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 472.71,
    y1: 53.3,
    x2: -421.2,
    y2: 884.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#819cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8d5fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    x1: 474.84,
    y1: 55.59,
    x2: -419.07,
    y2: 886.82,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m609.65,378.4v-203.09h42.16v77.43h78.95v-77.43h42.16v203.09h-42.16v-90.66h-78.95v90.66h-42.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m813.71,175.58h144.81v35.68h-102.65v46.71h89.98v35.27h-89.98v85.15h-42.16v-202.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1103.19,378.4h-42.16v-203.09h42.16v203.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1142.19,175.31h44.49l80.62,141.61v-141.61h39.54v203.09h-42.43l-82.68-144.1v144.1h-39.54v-203.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1465.49,175.31h44.09l-69.24,203.09h-40.09l-68.69-203.09h45.33l44.09,154.18,44.5-154.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1685.05,211.27h-107.47v43.13h98.65v35.27h-98.65v52.22h112.43v36.52h-153.91v-203.09h148.95v35.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1753.67,315.71c1.31,9.28,3.89,16.21,7.74,20.81,7.03,8.36,19.08,12.54,36.16,12.54,10.22,0,18.52-1.1,24.9-3.3,12.1-4.22,18.15-12.08,18.15-23.57,0-6.7-2.97-11.89-8.89-15.57-5.93-3.58-15.33-6.75-28.2-9.5l-21.99-4.83c-21.61-4.77-36.45-9.97-44.54-15.57-13.69-9.37-20.53-24.02-20.53-43.95,0-18.19,6.7-33.3,20.09-45.33,13.39-12.03,33.06-18.05,59-18.05,21.67,0,40.14,5.67,55.44,17.01,15.3,11.35,23.31,27.81,24.06,49.4h-40.78c-.75-12.22-6.21-20.89-16.38-26.04-6.78-3.39-15.21-5.1-25.29-5.1-11.21,0-20.15,2.21-26.84,6.61-6.69,4.41-10.03,10.56-10.03,18.46,0,7.26,3.3,12.68,9.89,16.26,4.23,2.39,13.23,5.19,26.98,8.41l35.64,8.4c15.62,3.67,27.33,8.59,35.13,14.74,12.1,9.56,18.16,23.38,18.16,41.47s-7.18,33.97-21.52,46.24c-14.34,12.25-34.61,18.39-60.79,18.39s-47.77-6.04-63.09-18.11c-15.32-12.08-22.98-28.69-22.98-49.81h40.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2058.86,175.31v35.96h-60.76v167.14h-42.71v-167.14h-61.04v-35.96h164.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2218.39,175.31h61.06v203.09h-39.54v-137.37c0-3.95.05-9.49.14-16.61.09-7.11.14-12.61.14-16.46l-38.49,170.44h-41.24l-38.21-170.44c0,3.85.04,9.35.14,16.46.09,7.12.14,12.66.14,16.61v137.37h-39.54v-203.09h61.75l36.97,159.69,36.69-159.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2468.91,211.27h-107.47v43.13h98.65v35.27h-98.65v52.22h112.43v36.52h-153.91v-203.09h148.95v35.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2506.25,175.31h44.49l80.62,141.61v-141.61h39.54v203.09h-42.43l-82.68-144.1v144.1h-39.54v-203.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2858.29,175.31v35.96h-60.76v167.14h-42.71v-167.14h-61.04v-35.96h164.51Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m489.51,312.51l-116.78,116.78-55.42-55.42,116.21-116.21-59.18-59.18-59.54,59.54-56.67-56.67,59.54-59.54L199.91,24.05l.57-.56c30.92-30.93,81.52-30.93,112.44,0l2,1.99,116.21,116.21,58.38,58.38c.27.27.53.54.8.81,30.12,30.99,29.86,80.98-.8,111.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m313.55,488.47l-.63.63c-30.65,30.65-80.65,30.92-111.63.8-.27-.27-.55-.53-.81-.8L23.88,312.51c-30.92-30.92-30.92-81.51,0-112.44l.63-.63,115.85-115.85,58.22,58.22-115.85,115.85,59.54,59.54,59.18-59.18,56.67,56.67-59.18,59.18,114.6,114.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfi);
export default __webpack_public_path__ + "static/media/hfi.d4a51f59dc1097d00bf58b9a434922a0.svg";
export { ForwardRef as ReactComponent };